// /* eslint-disable react/prop-types */
// import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@nextui-org/react';
// import { Dialog } from 'primereact/dialog';
// import { MultiSelect } from 'primereact/multiselect';
// import { useState } from 'react';
// import apiurl from '../../services/apiendpoint/apiendpoint';

// export default function Studenttable(props) {
//     const { data, sendEmail, loadingEmail, courses, batches, handleCourseChange, handleBatchChange, handleSaveCourses, selectedCourses, selectedBatches, editform, confirm2 ,
//         selectedStudents, setSelectedStudents
//     } = props;
//     const [modalVisible, setModalVisible] = useState(false);
//     const [modalContent, setModalContent] = useState({ type: '', url: '', title: '' });

//     const formattedCourses = Array.isArray(courses) ? courses.map((course) => ({ label: course.label || course.Course_Name || 'Unknown Course', value: course.value || course.Course_Name || 'unknown',})) : [];

//     const formattedBatches = Array.isArray(batches) ? batches.map((batch) => ({ label: batch.label || batch.Batch_Name || 'Unknown Batch',value: batch.value || batch.Batch_Name || 'unknown',})) : [];

//     const openModal = (type, relativePath, title) => {
//         const fullUrl = `${apiurl()}/${relativePath}`;
//         setModalContent({ type, url: fullUrl, title });
//         setModalVisible(true);
//     };

//     const closeModal = () => {
//         setModalVisible(false);
//         setModalContent({ type: '', url: '', title: '' });
//     };

//     const getFileExtension = (filename) => {
//         return filename.split('.').pop().toLowerCase();
//     };

//     const handleStudentSelection = (student, isChecked) => {
//         if (isChecked) {
//             setSelectedStudents((prev) => [...prev, student]);
//         } else {
//             setSelectedStudents((prev) => prev.filter((s) => s._id !== student._id));
//         }
//     };

//     const renderModalContent = () => {
//         const { type, url } = modalContent;
//         const extension = getFileExtension(url);

//         if (type === 'image' || ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
//             return (
//                 <img src={url} alt="Profile" className="max-w-full max-h-[80vh] object-contain"/>
//             );
//         } else if (type === 'document' || ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
//             if (extension === 'pdf') {
//                 return (
//                     <div className="w-full h-full lg:h-[80vh]">
//                         <iframe src={url} className="w-full h-full border-0" title="Document Viewer"/>
//                     </div>
//                 );
//             } else {
//                 return (
//                     <img src={url} alt="Aadhar Card" className="max-w-full max-h-[80vh] object-contain"/>
//                 );
//             }
//         } else {
//             return (
//                 <div className="p-4 text-center">
//                     <p className="text-gray-600">Cannot preview this file type</p>
//                 </div>
//             );
//         }
//     };

//     return (
//         <>
           
//             <div className="overflow-auto bg-white border rounded-xl h-[400px] xl:h-[500px] md:h-auto 2xl:h-[700px] my-5">
//                 <table className="divide-y divide-gray-200 rounded-xl">
//                     <thead>
//                         <tr>
//                             <th scope="col" className="px-3 py-5 text-sm font-medium text-start">
//                                 <input type="checkbox"
//                                     onChange={(e) => {
//                                         if (e.target.checked) {
//                                             setSelectedStudents(data?.resdata || []);
//                                         } else {
//                                             setSelectedStudents([]);
//                                         }
//                                     }}
//                                     checked={selectedStudents.length === data?.resdata?.length && data?.resdata?.length > 0}
//                                 />
//                             </th>
//                             <th scope="col" className="px-3 py-5 text-sm font-medium text-start">S.No.</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Action</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Full Name</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">DoB</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Gender</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Address</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Community</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Father Name</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Occupation</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Mobile Number</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Alternative Number</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Email Address</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Educational Qualification</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Name of the college</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">How you know</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Preferred Exam</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">UserName</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Password</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Application Status</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">User Status</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Profile Image</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Aadhar Card</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Send Mail</th>
//                             <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Add Course</th>
//                         </tr>
//                     </thead>
//                     <tbody className="divide-y divide-gray-200">
//                         {data?.resdata?.map((item, index) => (
//                             <tr key={index}>
//                                 <td scope="col" className="px-3 py-5 text-sm text-gray-500">
//                                     <input type="checkbox" checked={selectedStudents.some((s) => s._id === item._id)} onChange={(e) => handleStudentSelection(item, e.target.checked)}/>
//                                 </td>
//                                 <td scope="col" className="px-3 py-5 text-sm text-gray-500">{index + 1}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">
//                                     <Dropdown>
//                                         <DropdownTrigger>
//                                             <i className="text-lg cursor-pointer fi fi-rr-menu-dots-vertical"></i>
//                                         </DropdownTrigger>
//                                         <DropdownMenu aria-label="Dynamic Actions">
//                                             <DropdownItem onPress={() => editform(item)} color={"default"}>Edit</DropdownItem>
//                                             <DropdownItem onPress={() => confirm2(item._id)} color={"danger"} className={"text-danger"}>Delete</DropdownItem>
//                                         </DropdownMenu>
//                                     </Dropdown>
//                                 </td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Full_name}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Dob}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Gender}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Address}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Community}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Father_Name}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Occupation}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Mobile_Number}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Alternative_Number}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Email}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Educational_Qualification}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.College_Name}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.how_you_know}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.preferred_exam}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.UserName}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.password}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Application_Status}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Status}</td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">
//                                     {item.ProfileImage ? (
//                                         <button onClick={() => openModal('image', item.ProfileImage, `${item.Full_name} - Profile Image`)}
//                                             className="text-blue-500 transition-colors hover:text-blue-700" title="View Profile Image">
//                                             <i className="text-lg fi fi-rr-eye"></i>
//                                         </button>
//                                     ) : (
//                                         <span className="text-gray-400">No Image</span>
//                                     )}
//                                 </td>
//                                 <td scope="col" className="px-6 py-5 text-sm text-gray-500">
//                                     {item.Aadhar_card ? (
//                                         <button onClick={() => openModal('document', item.Aadhar_card, `${item.Full_name} - Aadhar Card`)}
//                                             className="text-blue-500 transition-colors hover:text-blue-700" title="View Aadhar Card">
//                                             <i className="text-lg fi fi-rr-eye"></i>
//                                         </button>
//                                     ) : (
//                                         <span className="text-gray-400">No Document</span>
//                                     )}
//                                 </td>
//                                 <td className="px-6 py-5 text-sm text-black">
//                                     <button
//                                         className={`p-1 rounded-lg bg-[#7828C8] text-white ${loadingEmail === item.Email ? 'opacity-50 cursor-not-allowed' : ''}`}
//                                         onClick={() => sendEmail(item.Email, item.UserName, item.password, item.Mobile_Number)}
//                                         disabled={loadingEmail === item.Email}
//                                     >
//                                         {loadingEmail === item.Email ? (
//                                             <svg className="inline-block w-5 h-5 mr-3 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                                                 <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                                                 <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
//                                             </svg>
//                                         ) : (
//                                             <svg className="inline-block w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
//                                                 <path strokeLinecap="round" strokeLinejoin="round" d="M4 4l16 8-16 8V4z" />
//                                             </svg>
//                                         )}
//                                     </button>
//                                 </td>
//                                 <td className="px-8 text-sm text-gray-500 py-7">
//                                     <div className='flex gap-3'>
//                                         <MultiSelect
//                                             value={selectedCourses[index] || []}
//                                             options={formattedCourses}
//                                             placeholder="Select Courses"
//                                             maxSelectedLabels={3}
//                                             className="w-full border border-gray-300 rounded-md p-multiselect"
//                                             onChange={(e) => handleCourseChange(e, index)}
//                                         />
//                                         <MultiSelect
//                                             value={selectedBatches[index] || []}
//                                             options={formattedBatches}
//                                             placeholder="Select Batches"
//                                             maxSelectedLabels={3}
//                                             className="w-full border border-gray-300 rounded-md p-multiselect"
//                                             onChange={(e) => handleBatchChange(e, index)}
//                                         />
//                                         <button className='bg-[#7828C8] p-1 text-white rounded-lg' onClick={() => handleSaveCourses(index)}>
//                                             <svg className="inline-block w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
//                                                 <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
//                                             </svg>
//                                         </button>
//                                     </div>
//                                 </td>
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>

//             <Dialog header={modalContent.title} visible={modalVisible} onHide={closeModal} style={{ width: '80vw', maxWidth: '900px' }} breakpoints={{ '960px': '90vw', '641px': '95vw' }}
//                 modal draggable={false} resizable={false} maximizable
//                 contentStyle={{ padding: '1rem', maxHeight: '70vh', overflow: 'auto' }}
//             >
//                 {renderModalContent()}
//             </Dialog>
//         </>
//     );
// }

/* eslint-disable react/prop-types */
import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@nextui-org/react';
import { Dialog } from 'primereact/dialog';
import { MultiSelect } from 'primereact/multiselect';
import { useState } from 'react';
import apiurl from '../../services/apiendpoint/apiendpoint';


export default function Studenttable(props) {
    const { data, sendEmail, loadingEmail, courses, batches, handleCourseChange, handleBatchChange, handleSaveCourses, selectedCourses, selectedBatches, editform, confirm2,
        selectedStudents, setSelectedStudents
    } = props;
    const [modalVisible, setModalVisible] = useState(false);
    const [modalContent, setModalContent] = useState({ type: '', url: '', title: '' });
    const [downloadingFiles, setDownloadingFiles] = useState(new Set());

    const formattedCourses = Array.isArray(courses) ? courses.map((course) => ({ label: course.label || course.Course_Name || 'Unknown Course', value: course.value || course.Course_Name || 'unknown', })) : [];

    const formattedBatches = Array.isArray(batches) ? batches.map((batch) => ({ label: batch.label || batch.Batch_Name || 'Unknown Batch', value: batch.value || batch.Batch_Name || 'unknown', })) : [];

    const openModal = (type, relativePath, title) => {
        const fullUrl = `${apiurl()}/${relativePath}`;
        setModalContent({ type, url: fullUrl, title });
        setModalVisible(true);
    };

    const closeModal = () => {
        setModalVisible(false);
        setModalContent({ type: '', url: '', title: '' });
    };

    const getFileExtension = (filename) => {
        return filename.split('.').pop().toLowerCase();
    };

    const handleStudentSelection = (student, isChecked) => {
        if (isChecked) {
            setSelectedStudents((prev) => [...prev, student]);
        } else {
            setSelectedStudents((prev) => prev.filter((s) => s._id !== student._id));
        }
    };

    const downloadDocument = async (studentId, documentType, studentName) => {
        const downloadKey = `${studentId}_${documentType}`;
        
        try {
            setDownloadingFiles(prev => new Set([...prev, downloadKey]));
            
            const response = await fetch(`${apiurl()}/application/download/${studentId}/${documentType}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                throw new Error('Download failed');
            }

            const contentDisposition = response.headers.get('Content-Disposition');
            let filename = `${studentName}_${documentType}.jpg`;
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
                if (filenameMatch) {
                    filename = filenameMatch[1];
                }
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

        } catch (error) {
            console.error('Download error:', error);
            alert('Failed to download document');
        } finally {
            setDownloadingFiles(prev => {
                const newSet = new Set(prev);
                newSet.delete(downloadKey);
                return newSet;
            });
        }
    };


    const renderModalContent = () => {
        const { type, url } = modalContent;
        const extension = getFileExtension(url);

        if (type === 'image' || ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
            return (
                <img src={url} alt="Profile" className="max-w-full max-h-[80vh] object-contain" />
            );
        } else if (type === 'document' || ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
            if (extension === 'pdf') {
                return (
                    <div className="w-full h-full lg:h-[80vh]">
                        <iframe src={url} className="w-full h-full border-0" title="Document Viewer" />
                    </div>
                );
            } else {
                return (
                    <img src={url} alt="Aadhar Card" className="max-w-full max-h-[80vh] object-contain" />
                );
            }
        } else {
            return (
                <div className="p-4 text-center">
                    <p className="text-gray-600">Cannot preview this file type</p>
                </div>
            );
        }
    };

    return (
        <>
            <div className="overflow-auto bg-white border rounded-xl h-[400px] xl:h-[500px] md:h-auto 2xl:h-[700px] my-5">
                <table className="divide-y divide-gray-200 rounded-xl">
                    <thead>
                        <tr>
                            <th scope="col" className="px-3 py-5 text-sm font-medium text-start">
                                <input type="checkbox"
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setSelectedStudents(data?.resdata || []);
                                        } else {
                                            setSelectedStudents([]);
                                        }
                                    }}
                                    checked={selectedStudents.length === data?.resdata?.length && data?.resdata?.length > 0}
                                />
                            </th>
                            <th scope="col" className="px-3 py-5 text-sm font-medium text-start">S.No.</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Action</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Full Name</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">DoB</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Gender</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Address</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">City</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Pincode</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Community</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Father Name</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Occupation</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Mobile Number</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Alternative Number</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Email Address</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Educational Qualification</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Name of the college</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">How you know</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Preferred Exam</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">UserName</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Password</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Application Status</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">User Status</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Profile Image</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Aadhar Card</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Send Mail</th>
                            <th scope="col" className="px-6 py-5 text-sm font-medium text-start">Add Course</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {data?.resdata?.map((item, index) => (
                            <tr key={index}>
                                <td scope="col" className="px-3 py-5 text-sm text-gray-500">
                                    <input type="checkbox" checked={selectedStudents.some((s) => s._id === item._id)} onChange={(e) => handleStudentSelection(item, e.target.checked)} />
                                </td>
                                <td scope="col" className="px-3 py-5 text-sm text-gray-500">{index + 1}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">
                                    <Dropdown>
                                        <DropdownTrigger>
                                            <i className="text-lg cursor-pointer fi fi-rr-menu-dots-vertical"></i>
                                        </DropdownTrigger>
                                        <DropdownMenu aria-label="Dynamic Actions">
                                            <DropdownItem onPress={() => editform(item)} color={"default"}>Edit</DropdownItem>
                                            <DropdownItem onPress={() => confirm2(item._id)} color={"danger"} className={"text-danger"}>Delete</DropdownItem>
                                        </DropdownMenu>
                                    </Dropdown>
                                </td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Full_name}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Dob}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Gender}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Address}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.City}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Pincode}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Community}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Father_Name}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Occupation}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Mobile_Number}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Alternative_Number}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Email}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Educational_Qualification}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.College_Name}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.how_you_know}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.preferred_exam}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.UserName}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.password}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Application_Status}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">{item.Status}</td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">
                                    {item.ProfileImage ? (
                                        <div className="flex gap-2">
                                            <button onClick={() => openModal('image', item.ProfileImage, `${item.Full_name} - Profile Image`)}
                                                className="text-blue-500 transition-colors hover:text-blue-700" title="View Profile Image">
                                                <i className="text-lg fi fi-rr-eye"></i>
                                            </button>
                                            <button 
                                                onClick={() => downloadDocument(item._id, 'profile', item.Full_name)}
                                                disabled={downloadingFiles.has(`${item._id}_profile`)}
                                                className="text-green-500 transition-colors hover:text-green-700 disabled:opacity-50" 
                                                title="Download Profile Image">
                                                {downloadingFiles.has(`${item._id}_profile`) ? (
                                                    <i className="text-lg fi fi-rr-spinner animate-spin"></i>
                                                ) : (
                                                    <i className="text-lg fi fi-rr-download"></i>
                                                )}
                                            </button>
                                        </div>
                                    ) : (
                                        <span className="text-gray-400">No Image</span>
                                    )}
                                </td>
                                <td scope="col" className="px-6 py-5 text-sm text-gray-500">
                                    {item.Aadhar_card ? (
                                        <div className="flex gap-2">
                                            <button onClick={() => openModal('document', item.Aadhar_card, `${item.Full_name} - Aadhar Card`)}
                                                className="text-blue-500 transition-colors hover:text-blue-700" title="View Aadhar Card">
                                                <i className="text-lg fi fi-rr-eye"></i>
                                            </button>
                                        </div>
                                    ) : (
                                        <span className="text-gray-400">No Document</span>
                                    )}
                                </td>
                                <td className="px-6 py-5 text-sm text-black">
                                    <button
                                        className={`p-1 rounded-lg bg-[#7828C8] text-white ${loadingEmail === item.Email ? 'opacity-50 cursor-not-allowed' : ''}`}
                                        onClick={() => sendEmail(item.Email, item.UserName, item.password, item.Mobile_Number)}
                                        disabled={loadingEmail === item.Email}
                                    >
                                        {loadingEmail === item.Email ? (
                                            <svg className="inline-block w-5 h-5 mr-3 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                                            </svg>
                                        ) : (
                                            <svg className="inline-block w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M4 4l16 8-16 8V4z" />
                                            </svg>
                                        )}
                                    </button>
                                </td>
                                <td className="px-8 text-sm text-gray-500 py-7">
                                    <div className='flex gap-3'>
                                        <MultiSelect
                                            value={selectedCourses[index] || []}
                                            options={formattedCourses}
                                            placeholder="Select Courses"
                                            maxSelectedLabels={3}
                                            className="w-full border border-gray-300 rounded-md p-multiselect"
                                            onChange={(e) => handleCourseChange(e, index)}
                                        />
                                        <MultiSelect
                                            value={selectedBatches[index] || []}
                                            options={formattedBatches}
                                            placeholder="Select Batches"
                                            maxSelectedLabels={3}
                                            className="w-full border border-gray-300 rounded-md p-multiselect"
                                            onChange={(e) => handleBatchChange(e, index)}
                                        />
                                        <button className='bg-[#7828C8] p-1 text-white rounded-lg' onClick={() => handleSaveCourses(index)}>
                                            <svg className="inline-block w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                             </svg>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                         ))}
                     </tbody>
                 </table>
             </div>

             <Dialog header={modalContent.title} visible={modalVisible} onHide={closeModal} style={{ width: '80vw', maxWidth: '900px' }} breakpoints={{ '960px': '90vw', '641px': '95vw' }}
                 modal draggable={false} resizable={false} maximizable
                 contentStyle={{ padding: '1rem', maxHeight: '70vh', overflow: 'auto' }}
             >
                 {renderModalContent()}
             </Dialog>
         </>
     );
}